export { default as PropertyPage } from './Property'
